import InputNumber from 'rc-input-number';
import { useDispatch, useSelector } from 'react-redux';

import { OperatorField } from './OperatorField';
import { OperatorsActions } from '../../store/reducers/operators';
import { HANDLING_FEE_LINE, HANDLING_FEE_NONE, HANDLING_FEE_ORDER } from '../../constants/operators';
import { decimalFormatter } from '../../utils/formatHelper';
import Select from '../common/Select';

import styles from './OperatorComponents.module.scss';

const handlingFeeOptions = [
  { label: 'None', value: HANDLING_FEE_NONE },
  { label: 'Order', value: HANDLING_FEE_ORDER },
  { label: 'Line', value: HANDLING_FEE_LINE },
];

export function OperatorHandlingFee() {
  const dispatch = useDispatch();

  const {
    configuration: { handlingFee },
  } = useSelector((state) => state.operators);

  const updateHandlingFee = (payload) => {
    dispatch({ type: OperatorsActions.configuration, payload: { handlingFee: { ...handlingFee, ...payload } } });
  };

  return (
    <OperatorField
      title="Handling Fee"
      description="The agreed-upon handling fee (processing fee) negotiated with the vendor (applied per order or per line item) will be invoiced in addition to the product cost."
    >
      <Select
        options={handlingFeeOptions}
        value={handlingFee?.type || HANDLING_FEE_NONE}
        onChange={(value) => updateHandlingFee({ type: value })}
      />
      <div className={styles.handlingFee}>
        <label htmlFor="amount-input">Amount:</label>
        <InputNumber
          onChange={(value) => updateHandlingFee({ formula: value })}
          min={0}
          onFocus={(e) => e.target.select()}
          onClick={(e) => e.target.select()}
          value={handlingFee?.formula ?? 0}
          formatter={decimalFormatter}
          step={0.1}
          disabled={handlingFee?.type === HANDLING_FEE_NONE}
        />
      </div>
    </OperatorField>
  );
}
